<template>
  <v-card flat class="ma-0 pa-0" style="background-color: var(--color-surface-container) !important;">
    <v-parallax class="hero-image" :height="$vuetify.breakpoint.mobile ? 525 : 770" :src="$vuetify.breakpoint.mobile ? require('@/assets/images/ifpi-start-hero-mobile.jpg') : require('@/assets/images/ifpi-start-hero-desktop.jpg')">
      <div class="d-flex fill-height flex-column align-center justify-center">
        <v-card-title class="display-2 text-center hero-title" :class="$vuetify.breakpoint.mobile ? '' : 'mb-8'" v-html="$t('login.title')"></v-card-title>
        <div v-if="!$vuetify.breakpoint.mobile" class="d-flex">
          <v-btn color="secondary" @click="login(null)" class="t-login-btn mr-6">{{ $t('login.btn-email-text') }}</v-btn>
          <v-btn color="secondary" @click="login('sms')" class="t-login-btn">{{ $t('login.btn-sms-text') }}</v-btn>
        </div>
      </div>
    </v-parallax>
    <v-card-text v-if="$vuetify.breakpoint.mobile" class="d-flex flex-column align-center pt-6">
      <v-btn color="secondary" @click="login(null)" class="t-login-btn mb-3" block>{{ $t('login.btn-email-text') }}</v-btn>
      <v-btn color="secondary" @click="login('sms')" class="t-login-btn" block>{{ $t('login.btn-sms-text') }}</v-btn>
    </v-card-text>
    <v-card-text class="body-1"><p v-html="$t('login.info')"></p></v-card-text>
  </v-card>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'Login',

  data: () => ({
    contentLocale: ''
  }),

  watch: {
    locale() {
      this.$store.dispatch('app/loadLoginContent', this.locale)
      this.contentLocale = this.locale
    },
  },

  mounted() {
    if (!this.loginContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadLoginContent', this.locale)
      this.contentLocale = this.locale
    }
  },


  computed: {
    ...mapGetters('app', ['loginContent', 'locale']),
  },

  methods: {
    login(connType) {
      this.$auth.loginWithRedirect(connType)
    },
  }

}
</script>

<style>

</style>